import React, {useState, useEffect} from "react";
import stateMap from "store/stateMap";
import { connect } from 'react-redux';
import Interests from "component/Interests/Interests";
import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import "./index.scss";
import { popinfo } from "component/Fancybox/Fancybox";
import _ from "lodash";
import { PageCredential } from "component/PageCredential";

const PageProfileInterest = connect(stateMap)((props) => {
    const[userInterests, setUserInterests] = useState(false);

    const SaveInterest = (e) => {
        e.preventDefault();

        var SavingLoader = popinfo('loader', 'Saving Interest', 'Please Wait');

        api('/Profile/Interest', 'post', {
            interest : _.map(_.filter(userInterests, function(interest){
                return interest.isSelected;
            }),_.property('InterestID')) 
        }, 'Bearer ' + props.auth.token)
            .then(function(){
                SavingLoader.close();
            })
            .catch((error) => {
                popinfo('error', 'Saving Interest', error, {}, SavingLoader);
            });
    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        api('/Profile/Interest', 'get', {
            user_id : props.auth.user.UserID
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                setUserInterests(response.interest);
            })

    },[props.auth.user]);

    return (
        <div className="page-profile-interest container">
            <BlockHeader title="Manage Your Interest" desc="Choose your interest to get better initiative recommendation"/>
            <PageCredential title="My Interests"/>
            <div>
                {
                    userInterests === false 
                    ? <span className="skeleton"></span> 
                    : 
                    <div>
                        <Interests selectedInterests={userInterests} selectInterest={(Sentinterests) => {
                            setUserInterests(Sentinterests);
                        }}/>
                        <hr />
                        <div className="text-right">
                            <button className="btn btn-orange" onClick={ SaveInterest }>Update Interest</button>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
})

export default PageProfileInterest;